import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = { class: "border border-gray-300 rounded-md p-4" }
const _hoisted_3 = { class: "flex flex-col md:flex-row gap-x-4" }
const _hoisted_4 = { class: "flex justify-end" }
const _hoisted_5 = { class: "border border-gray-300 rounded-md p-4" }
const _hoisted_6 = { class: "flex justify-end mt-2" }
const _hoisted_7 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanySelector = _resolveComponent("CompanySelector")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, {
      style: {"height":"calc(100vh - 80px)"},
      class: "bg-white"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { style: {"padding":"0px","height":"auto"} }, {
          default: _withCtx(() => [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "h-12 p-4 shadow-md" }, "システム設定 > センサー管理", -1)),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form, {
                  model: _ctx.searchForm,
                  "label-width": "auto"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_form_item, {
                        label: "契約会社",
                        class: "md:w-80"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CompanySelector, {
                            modelValue: _ctx.searchForm.company_code,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.company_code) = $event)),
                            isSearch: true,
                            disabled: _ctx.loginUserRole !== _ctx.ROLES.SYSTEM
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        class: "w-24",
                        type: "primary",
                        onClick: _ctx.handleSearchButton
                      }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode("検索")
                        ])),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_button, {
                    class: "w-24 mr-4",
                    type: "primary",
                    onClick: _ctx.handleAddButton
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("新規登録")
                    ])),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_upload, {
                    ref: "upload",
                    "on-change": _ctx.handleImportButton,
                    "auto-upload": false,
                    "show-file-list": false,
                    accept: ".csv"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "w-30",
                        type: "primary"
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode("インポート")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["on-change"])
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_main, { style: {"padding-block":"0px"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_table, {
                data: _ctx.mTableData,
                height: 'calc(100vh - 380px)'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "company_code",
                    label: "契約会社",
                    width: "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "sensor_type",
                    label: "センサー種別"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.sensor_type === 'calera' ? '体温センサー' : '心拍センサー'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "address",
                    label: "センサーMAC"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "inuse",
                    width: "80",
                    label: "使用中",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getFlag(scope.row.inuse)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "削除",
                    width: "60",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      (!scope.row.inuse)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "danger",
                            link: "",
                            onClick: ($event: any) => (_ctx.handleDeleteButton(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Delete)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_pagination, {
                "current-page": _ctx.mCurrentPage,
                "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mCurrentPage) = $event)),
                "page-size": _ctx.mPageSize,
                "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mPageSize) = $event)),
                "page-sizes": [10, 20, 50],
                layout: "total, sizes, prev, pager, next, jumper",
                total: _ctx.mTotalRecords,
                onSizeChange: _ctx.handleSizeChange,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
            ])
          ]),
          _: 1
        })), [
          [_directive_loading, _ctx.loading]
        ]),
        _createVNode(_component_el_footer, { style: {"height":"20px"} })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      title: _ctx.form.add_update === 'add' ? 'センサー新規登録' : 'センサー編集',
      width: "600px",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("キャンセル")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleAddUpdateSubmit(_ctx.formRef)))
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode("確認")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formRef",
          "label-width": "auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form._id,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form._id) = $event)),
              hidden: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_form_item, {
              label: "所属会社",
              prop: "company_code"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CompanySelector, {
                  modelValue: _ctx.form.company_code,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.company_code) = $event)),
                  disabled: _ctx.loginUserRole !== _ctx.ROLES.SYSTEM
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "センサー種別",
              prop: "sensor_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.sensor_type,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.sensor_type) = $event)),
                  placeholder: "センサー種別をを選択してください"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "体温センサー",
                      value: "calera"
                    }),
                    _createVNode(_component_el_option, {
                      label: "心拍センサー",
                      value: "hrm"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "センサー MAC",
              prop: "address"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.address,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.address) = $event)),
                  placeholder: "センサー MACを入力"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}